<ns-page-container sidebarHeader="Wybierz dokumenty, które chcesz dodać do swojej biblioteki.">

    <ng-container page-sidebar>
        <ns-my-documents-upload
          (save)="onSaveFile($event)"
          [formGroup]=""
        ></ns-my-documents-upload>
    </ng-container>

    <ng-container page-content>
        <ns-my-documents-list
          [list]="myDocuments.data"
        ></ns-my-documents-list>
    </ng-container>

</ns-page-container>
